import { useCallback } from 'react'
import { runDeferredCheckoutRefresh } from './upsellCheckoutRefresh'

export function useUpsellSuccessClose(closeFlow, isSuccessStepActive) {
  return useCallback(() => {
    if (isSuccessStepActive) {
      runDeferredCheckoutRefresh()
    }

    closeFlow()
  }, [closeFlow, isSuccessStepActive])
}
